import { render, staticRenderFns } from "./StakingRecord.vue?vue&type=template&id=1da96cf5&scoped=true"
import script from "./StakingRecord.vue?vue&type=script&lang=js"
export * from "./StakingRecord.vue?vue&type=script&lang=js"
import style0 from "./StakingRecord.vue?vue&type=style&index=0&id=1da96cf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da96cf5",
  null
  
)

export default component.exports